import { useToast } from "../../hooks/use-toast";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "./toast";

export function Toaster() {
  const { toasts } = useToast();
  const firstToast = toasts[0];
  const isTop = firstToast?.position === "top";

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport 
        className={isTop ? "fixed top-0 left-1/2 -translate-x-1/2 flex-col-reverse p-4 sm:top-0 sm:bottom-auto sm:right-auto sm:flex-col md:max-w-[420px]" : undefined} 
      />
    </ToastProvider>
  );
}
